import { BoatAvailabilityMode } from "@repo/rq-api-public";
import { useListingQuery } from "../../api/hooks";
import { getImageUrl } from "../../utils/image";
import { textStyles } from "../../styles/typography";
import { ccn } from "../../styles/utils";

export default function SeatBasedBoatInfo() {
  const { data: listing } = useListingQuery();
  const boat = listing?.boat;

  if (boat?.availabilityMode !== BoatAvailabilityMode.SeatBased) return null;
  if (!boat.boatPicture && !boat.makeAndModel && !boat.description) return null;

  return (
    <section className="widget-seat-based-boat-info mb-6 flex flex-col gap-3">
      {boat.boatPicture && (
        <img
          src={getImageUrl(boat.boatPicture, { width: 800, height: 450 })}
          alt={boat.makeAndModel || listing?.title || "Boat"}
          className="h-48 w-full rounded-xl object-cover"
        />
      )}
      {boat.makeAndModel && (
        <h2 className={ccn(textStyles.h2, "text-blue-dark60")}>
          {boat.makeAndModel}
        </h2>
      )}
      {boat.description && (
        <p className="whitespace-pre-line text-blue-dark60">
          {boat.description}
        </p>
      )}
    </section>
  );
}
